// Utils
import translation from '@translations/en.json';
import { AppPath } from '@utils/index';
// Types
import { BreadcrumbDefinition } from './Breadcrumb.type';

const text = translation.breadcrumb;

export const definitionList: BreadcrumbDefinition[] = [
  {
    route: `${AppPath.FLEET_PERFORMANCE_ANALYSIS}/[imo]`,
    title: `${text.fleet_performance_vessel.title}:`,
    text: text.fleet_performance_vessel.text,
    href: AppPath.FLEET_PERFORMANCE_ANALYSIS,
    withVessel: true,
  },
  {
    route: AppPath.FLEET_PERFORMANCE_ANALYSIS,
    title: `${text.fleet_performance.title}:`,
    text: text.fleet_performance.text,
  },
  {
    route: `${AppPath.CII_SIMULATOR}/[imo]`,
    title: `${text.cii_simulator.title}:`,
    text: text.cii_simulator.text,
    href: AppPath.FLEET_CII_RATINGS,
    withVessel: true,
  },
  {
    route: AppPath.FLEET_CII_RATINGS,
    title: `${text.fleet_cii_ratings.title}:`,
    text: text.fleet_cii_ratings.text,
  },
  {
    route: AppPath.FLEET_EEOI_SCORES,
    title: `${text.fleet_eeoi_scores.title}:`,
    text: text.fleet_eeoi_scores.text,
  },
  {
    route: AppPath.LOGIN,
    title: text.login.title,
  },
  {
    route: AppPath.FORGOT_PASSWORD,
    title: text.forgot_password.title,
  },
  {
    route: AppPath.EXPIRED_LINK,
    title: text.expired_link.title,
  },
  {
    route: AppPath.ACCOUNT_CREATED_SUCCESSFULLY,
    title: text.account_created_successfully.title,
  },
  {
    route: AppPath.SERVER_ERROR,
    title: text.server_error.title,
  },
  {
    route: AppPath.NOT_FOUND,
    title: text.not_found.title,
  },
  {
    route: AppPath.HOME,
    title: text.home.title,
  },
];
